module.exports = __webpack_public_path__ + "img/fuji.364062af.svg";